import { render } from "./CountdownOverlayComponent.vue?vue&type=template&id=481f04d1&scoped=true"
import script from "./CountdownOverlayComponent.vue?vue&type=script&lang=js"
export * from "./CountdownOverlayComponent.vue?vue&type=script&lang=js"

import "./CountdownOverlayComponent.vue?vue&type=style&index=0&id=481f04d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481f04d1"]])

export default __exports__